<template>
  <widget-template title="Claims Status Summary">
    <div slot="title">
      <div>
        <div class="headline">My Claims Notifications</div>
        <span class="grey--text">{{ myClaimsNotifications.info }}</span>
      </div>
    </div>
    <div>
      <span class="pr-2 pl-2">
        <v-menu offset-y :max-height="300">
          <template v-slot:activator="{ on }">
            <v-tooltip top>
              <v-layout align-center v-on="on"> <v-icon>mdi-calendar-today</v-icon> {{ selectedWidgetScope.description }} </v-layout>
              <span>{{ selectedWidgetScope.info }}</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item v-for="(option, key) in widgetScopes" :key="key" @click="doSelectWidgetScope(key)">
              <v-list-item-title>{{ option.description }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </span>
      |
      <span class="pr-2 pl-2">
        <v-menu offset-y :max-height="300">
          <template v-slot:activator="{ on }">
            <v-tooltip top>
              <v-layout align-center v-on="on"> <v-icon>mdi-view-grid</v-icon> {{ selectedAppId.description }} </v-layout>
              <span>
                {{ permittedAppIdsText }}
              </span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item v-for="(appId, index) in appIds" :key="index" @click="doSelectAppId(appId.id)">
              <v-list-item-title>{{ appId.description }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </span>
    </div>
    <div class="mt-4" style="position: relative">
      <v-layout>
        <v-flex lg12 md12 xs12>
          <v-card class="mt-4 mx-auto" max-width="520">
            <v-sheet class="v-sheet--offset mx-auto" color="cyan" elevation="6" max-width="calc(100% - 32px)">
              <chartist
                v-if="ctDataFlag"
                ratio="ct-major-tenth"
                type="Bar"
                :data="ctData"
                :options="ctOptions"
                :responsiveOptions="responsiveOptions"
              >
              </chartist>
              <v-card-text class="pt-4" v-if="!ctDataFlag">
                <v-spacer class="mt-5"></v-spacer>
                <v-flex xs12 class="text-xs-center white--text"> No available data. </v-flex>
                <v-spacer class="mt-5"></v-spacer>
              </v-card-text>
            </v-sheet>
            <v-card-text class="pt-0">
              <v-icon color="#097c40" class="mr-2" small>mdi-brightness-1</v-icon>
              <span class="caption font-weight-light"><strong style="color: #097c40">Converted&nbsp;&nbsp;&nbsp;&nbsp;</strong></span>
              <v-icon color="#f05b4f" class="mr-2" small>mdi-brightness-1</v-icon>
              <span class="caption font-weight-light"><strong style="color: #f05b4f">Unconverted</strong></span>
              <v-divider class="my-2"></v-divider>
              <div slot="action">
                <div v-if="initState === 0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="grey--text">
                        <v-icon small color="orange">mdi-record</v-icon>
                        Loading...
                      </span>
                      <span>Loading</span>
                    </template>
                  </v-tooltip>
                </div>
                <div v-else-if="initState === 1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <div v-on="on" @click="doReload" class="widgetAction grey--text">
                        <v-icon small>mdi-refresh</v-icon>
                        Updated {{ lastUpdated }} ago
                      </div>
                      <span>Click to update</span>
                    </template>
                  </v-tooltip>
                </div>
                <div v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" @click="doReload" class="widgetAction grey--text">
                        <v-icon small color="red">mdi-record</v-icon>
                        Error
                      </span>
                      <span>Click to retry</span>
                    </template>
                  </v-tooltip>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </widget-template>
</template>

<script>
import { mapActions } from 'vuex'
import { formatDisplayTimeDistance } from '@/utils/date'
import { longScopeMixin } from '../longScopeMixin'

export default {
  data() {
    return {
      widgetForm: {
        scope: 'today',
        appId: 'all'
      },
      ctDataFlag: false,
      ctData: {},
      ctOptions: {
        seriesBarDistance: 35
      },
      responsiveOptions: [
        [
          'screen and (max-width: 640px)',
          {
            seriesBarDistance: 35,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value[0]
              }
            }
          }
        ]
      ]
    }
  },
  watch: {
    'myClaimsNotifications.chartInfo': function (value) {
      this.compileData(value)
    }
  },
  computed: {
    myClaimsNotifications() {
      return this.$store.state.widgets.myClaimsNotifications
    },
    initState() {
      return this.myClaimsNotifications.init
    },
    lastUpdated() {
      return formatDisplayTimeDistance(this.myClaimsNotifications.lastUpdated, this.timeNow)
    },
    permittedAppIdsText() {
      return this.formatPermitAppIdsText(this.myClaimsNotifications.appIds)
    }
  },
  methods: {
    ...mapActions(['initMyClaimsNotifications']),
    doReload() {
      // Combine Form
      this.widgetForm.scope = this.widgetScopeForm.scope
      this.widgetForm.appId = this.appIdForm.appId
      this.initMyClaimsNotifications(this.widgetForm)
    },
    compileData(value) {
      if (value[0].cData.labels.length === 0) {
        this.ctDataFlag = false
      } else {
        this.ctDataFlag = true
        this.ctData = value[0].cData
      }
    }
  },
  mounted() {
    if (this.initState !== 1) {
      // Default values
      this.doSelectWidgetScope('today', false)
      this.doSelectAppId('all')
    } else {
      // Doesnt want to do auto refresh here (save bandwidth, let user do it manually)
      if (this.myClaimsNotifications.scope) {
        this.doSelectWidgetScope(this.myClaimsNotifications.scope, false)
      }
      if (this.myClaimsNotifications.appId) {
        this.doSelectAppId(this.myClaimsNotifications.appId, false)
      }
      // compile data
      this.compileData(this.myClaimsNotifications.chartInfo)
    }
  },
  mixins: [longScopeMixin()]
}
</script>

<style lang="scss">
@import 'chartist/dist/scss/chartist.scss';
.v-sheet {
  border-radius: 4px !important;
}
.v-sheet--offset {
  top: -24px;
  position: relative;
}
.v-card--material-stats.v-card .v-offset .v-card {
  max-width: 85px;
  max-height: 85px;
  line-height: 85px;
  padding: 15px !important;
}
.ct-series-a .ct-line {
  /* Set the colour of this series line */
  stroke: #e5e5e5;
}
.ct-series-a .ct-point {
  /* Colour of your points */
  stroke: #e5e5e5;
}
.ct-series-a .ct-bar {
  /* Colour of your bars */
  stroke: #e5e5e5;
}
.ct-label {
  fill: #e5e5e5 !important;
  color: #e5e5e5 !important;
  font-size: 0.75rem;
  line-height: 1;
}
.ct-series-a .ct-slice-pie {
  fill: rgb(50, 165, 241);
  stroke: #e5e5e5;
  stroke-width: 2px;
}
.ct-bar {
  stroke-width: 30px !important;
}
.ct-series-a .ct-bar {
  stroke: #097c40;
}
.ct-series-b .ct-bar {
  stroke: #f05b4f;
}
</style>
